module.exports = __webpack_public_path__ + "img/clock-file.333c049f.svg";